import { Plugin } from '@nuxt/types';
import createPersistedState from 'vuex-persistedstate';

export default <Plugin>(({ store }) => {
  createPersistedState({
    key: 'vuex',
    paths: ['persistent'],
  })(store);
});
